<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col md="12">
                <b-card>
                    <div slot="header">
                        <b-row>
                            <b-col md="6" class="text-start">
                                <strong>Zone Master</strong>
                            </b-col>
                            <b-col md="6" class="text-right">
                                <b-button variant="primary" size="sm" @click="addzone()"><i class="fa fa-plus" aria-hidden="true"></i>
                                    ADD Zone</b-button>&nbsp;
                                <b-button variant="primary" size="sm" @click="searchzone()"><i class="fa fa-search" aria-hidden="true"></i> Search</b-button>
                            </b-col>
                        </b-row>
                    </div>

                    <div v-if="add_zone">
                        <div>
                            <b-tabs content-class="mt-3"  align="start">
                              <b-tab title="ADD Zone" @click="checktab('Add_Zone')">
                                <div class="p-4" >
                                    <b-form
                                    @submit.prevent="validateForm('form-1')"
                                    data-vv-scope="form-1">
                                        <b-row>
                                            <b-col md="4" class="mb-3">
                                                <b-form-group>
                                                    <b>Client Name <span style="color: red;">*</span></b>
                                                    <v-select :options="clientname" v-model="customer.selectclientname" name="client name" placeholder="Select Client Name" class="mt-2"  v-validate="'required'"
                                                    :class="{ input: true, 'text-danger': errors.has('form-1.client name'),
                                                    }" ></v-select>
                                                    <b-input-group class="mb-3">
                                                        <span class="icon has-text-warning">
                                                        <i
                                                            class="fa fa-warning"
                                                            v-show="errors.has('client name')"
                                                        ></i>
                                                        </span>
                                                        <span
                                                        style="width:240px"
                                                        v-show="errors.has('form-1.client name')"
                                                        class="help text-danger"
                                                        >{{ errors.first("form-1.client name") }}</span
                                                        >
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
        
                                            <b-col md="4" class="mb-3">
                                                <b-form-group>
                                                    <b>Client Service <span style="color: red;">*</span></b>
                                                    <v-select :options="clientservice" v-model="customer.selectclientservice"
                                                     name="client service" placeholder="Select Client Service" class="mt-2" v-validate="'required'"
                                                    :class="{ input: true, 'text-danger': errors.has('form-1.client service'),
                                                    }" ></v-select>
                                                    <b-input-group class="mb-3">
                                                        <span class="icon has-text-warning">
                                                        <i
                                                            class="fa fa-warning"
                                                            v-show="errors.has('client service')"
                                                        ></i>
                                                        </span>
                                                        <span
                                                        style="width:240px"
                                                        v-show="errors.has('form-1.client service')"
                                                        class="help text-danger"
                                                        >{{ errors.first("form-1.client service") }}</span
                                                        >
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
        
                                            <b-col md="4" class="mb-3">
                                                <b-form-group>
                                                    <b>IS Active <span style="color: red;">*</span></b>
                                                    <b-form-select v-model="customer.selectedstatus" :options="options" class="mt-2" name="status" v-validate="'required'"
                                                    :class="{ input: true, 'is-invalid': errors.has('form-1.status'),
                                                    }"></b-form-select>
                                                    <b-input-group class="mb-3">
                                                        <span class="icon has-text-warning">
                                                        <i
                                                            class="fa fa-warning"
                                                            v-show="errors.has('status')"
                                                        ></i>
                                                        </span>
                                                        <span
                                                        style="width:240px"
                                                        v-show="errors.has('form-1.status')"
                                                        class="help text-danger"
                                                        >{{ errors.first("form-1.status") }}</span
                                                        >
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
        
                                            <b-col md="4" class="mb-3">
                                                <b>Zone Name <span style="color: red;">*</span></b>
                                                <b-form-textarea id="textarea" v-model.trim="customer.text" placeholder="Enter something..."
                                                rows="3" max-rows="6" class="mt-2" name="Zone name" v-validate="'required'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-1.status'),
                                                }"></b-form-textarea>
                                                <b-input-group class="mb-3">
                                                    <span class="icon has-text-warning">
                                                    <i
                                                        class="fa fa-warning"
                                                        v-show="errors.has('Zone name')"
                                                    ></i>
                                                    </span>
                                                    <span
                                                    style="width:240px"
                                                    v-show="errors.has('form-1.Zone name')"
                                                    class="help text-danger"
                                                    >{{ errors.first("form-1.Zone name") }}</span
                                                    >
                                                </b-input-group>
                                                
                                            </b-col>
        
                                            <b-col md="4" class="mt-5">
                                                <b-button variant="primary" size="md"  type="submit"> <i class="fa fa-check-circle-o" aria-hidden="true"></i> Save</b-button> &nbsp;
                                                <b-button variant="danger" @click="clear()"><i class="fa fa-ban" aria-hidden="true"></i> Clear</b-button>
                                            </b-col>
                                        </b-row>
                                    </b-form>
                                </div>
                              </b-tab>
                              <b-tab title="Upload Bulk Zone" @click="checktab('Uploadbulk_Zone')">
                                <div class="text-right mr-4">

                                    <a href="img/SampleZoneNameCSV.csv" download="SampleForZone.csv" target="_blank"
                                    >
                                        <b-button variant="primary" size="sm"  type="submit"> <i class="fa fa-download" aria-hidden="true"></i> Download Sample CSV</b-button> 
                                    </a>
                               </div>
                                <div class="p-4" >
                                   <b-form
                                    @submit.prevent="validateForm2('form-3')"
                                    data-vv-scope="form-3">
                                        <b-row>
                                            <b-col md="4" class="mb-3">
                                                <b-form-group>
                                                    <b>Client Name <span style="color: red;">*</span></b>
                                                    <v-select :options="clientname" v-model="uplodCustomer.selectclientname" name="client name" placeholder="Select Client Name" class="mt-2"  v-validate="'required'"
                                                    :class="{ input: true, 'text-danger': errors.has('form-3.client name'),
                                                    }" ></v-select>
                                                    <b-input-group class="mb-3">
                                                        <span class="icon has-text-warning">
                                                        <i
                                                            class="fa fa-warning"
                                                            v-show="errors.has('client name')"
                                                        ></i>
                                                        </span>
                                                        <span
                                                        style="width:240px"
                                                        v-show="errors.has('form-3.client name')"
                                                        class="help text-danger"
                                                        >{{ errors.first("form-3.client name") }}</span
                                                        >
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
        
                                            <b-col md="4" class="mb-3">
                                                <b-form-group>
                                                    <b>Client Service <span style="color: red;">*</span></b>
                                                    <v-select :options="clientservice" v-model="uplodCustomer.selectclientservice"
                                                     name="client service" placeholder="Select Client Service" class="mt-2" v-validate="'required'"
                                                    :class="{ input: true, 'text-danger': errors.has('form-3.client service'),
                                                    }" ></v-select>
                                                    <b-input-group class="mb-3">
                                                        <span class="icon has-text-warning">
                                                        <i
                                                            class="fa fa-warning"
                                                            v-show="errors.has('client service')"
                                                        ></i>
                                                        </span>
                                                        <span
                                                        style="width:240px"
                                                        v-show="errors.has('form-3.client service')"
                                                        class="help text-danger"
                                                        >{{ errors.first("form-3.client service") }}</span
                                                        >
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
        
                                            <b-col md="4" class="mb-3">
                                                <b-form-group>
                                                    <b>IS Active <span style="color: red;">*</span></b>
                                                    <b-form-select v-model="uplodCustomer.selectedstatus" :options="options" class="mt-2" name="status" v-validate="'required'"
                                                    :class="{ input: true, 'is-invalid': errors.has('form-3.status'),
                                                    }"></b-form-select>
                                                    <b-input-group class="mb-3">
                                                        <span class="icon has-text-warning">
                                                        <i
                                                            class="fa fa-warning"
                                                            v-show="errors.has('status')"
                                                        ></i>
                                                        </span>
                                                        <span
                                                        style="width:240px"
                                                        v-show="errors.has('form-3.status')"
                                                        class="help text-danger"
                                                        >{{ errors.first("form-3.status") }}</span
                                                        >
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
        
                                            <b-col md="4" class="mb-3">
                                                <b-form-group>
                                                    <b>Upload File <span style="color: red;">*</span></b>
                                                    <br>
                                                    <b-form-file 
                                                    accept=".csv"
                                                    v-model="uplodCustomerfile1"                 :state="Boolean(uplodCustomerfile1)" 
                                                    @change="selectcsvFiletoUpload($event)"
                                                    placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." name="upload file" v-validate="'required'"
                                                    :class="{ input: true, 'is-invalid': errors.has('form-3.upload file'),
                                                    }"
                                                    ></b-form-file>
                                                    <b-input-group class="mb-3">
                                                        <span class="icon has-text-warning">
                                                        <i
                                                            class="fa fa-warning"
                                                            v-show="errors.has('upload file')"
                                                        ></i>
                                                        </span>
                                                        <span
                                                        style="width:240px"
                                                        v-show="errors.has('form-3.upload file')"
                                                        class="help text-danger"
                                                        >{{ errors.first("form-3.upload file") }}</span
                                                        >
                                                    </b-input-group>
                                                </b-form-group>
                                                
                                            </b-col>
        
                                            <b-col md="4" class="mt-4">
                                                <b-button variant="primary" size="md"  type="submit"> <i class="fa fa-check-circle-o" aria-hidden="true"></i> Submit</b-button> &nbsp;
                                                <b-button variant="danger" @click="clear()"><i class="fa fa-ban" aria-hidden="true"></i> Clear</b-button>
                                            </b-col>
                                        </b-row>
                                    </b-form>
                                </div>
                              </b-tab>
                            </b-tabs>
                        </div>
                    </div>

                    <div v-if="search_zone">
                        <b-card>
                            <b-row>
                                <b-col md="5">
                                    <b>Zone Name</b>&nbsp; 
                                    <b-input type="text" class="mt-2" placeholder="Enter Zone Name" v-model.trim="searchzonename"/>
                                </b-col>
                                <b-col md="4">
                                    <b>IS Active </b>
                                    <b-form-select v-model="searchstatus" :options="options" class="mt-2"></b-form-select>
                                </b-col>
                                <b-col md="3" class="mt-4">
                                    <b-button variant="primary" size="md" @click="ZoneList(pageNum)"> <i class="fa fa-search" aria-hidden="true"></i> Search</b-button> &nbsp;
                                    <b-button variant="danger" @click="clear()"><i class="fa fa-ban" aria-hidden="true"></i> Clear</b-button>
                                </b-col>
                            </b-row>
                        </b-card>
                    </div>

                    <div class="pl-5 pr-5" v-if="showtable">
                        <table>
                            <tr>
                                <th style="border: 1px solid #7c7676; background: #0080008f;" class="text-center">Success Count</th>
                                <th style="border: 1px solid #7c7676;     background: #ff000082;" class="text-center">Failure  Count</th>
                            </tr>
                            <tr>
                                <td style="border: 1px solid #7c7676;">
                                    <a :href="successCSV" target="_blank" rel="noopener noreferrer" v-if="successCount>0" @click="downloadsuccessCSV()" style="color: #000;  text-decoration:none;"  data-toggle="tooltip"
                                        title="CSV Success Count">
                                        <b-button variant="light">{{successCount}}</b-button>
                                    </a>
                                    <span v-else>{{successCount}}</span>
                                </td>
                                
                                <td style="border: 1px solid #7c7676;">
                                    <a :href="rejectCSV" target="_blank" rel="noopener noreferrer" v-if="failureCount>0" @click="downloadrejectCSV()" style="color: #000;  text-decoration:none;"  data-toggle="tooltip"
                                        title="CSV Rejected Count">
                                        <b-button variant="light">{{failureCount}}</b-button>
                                    </a>
                                    <span v-else>{{failureCount}}</span>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <br>

                    <!-- // Table list Tab -->
                    <div>
                        <b-tabs content-class="mt-3" justified>
                            <b-tab title="Zone Details" active>
                                <div class="m-3">
                                    <b-row>
                                        <b-col md="12" class="text-right">
                                            <b text-variant="red">Total Records :<span style="color: red;"> {{totalRows}}</span></b>
                                        </b-col>
                                        <b-col md="12">
                                            <b-table show-empty responsive :items="items" :fields="fields" :current-page="currentPage"  :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection" :outlined="outlined" :busy="isBusy">
                                                <div slot="table-busy" class="text-center text-danger my-2">
                                                    <b-spinner class="align-middle"></b-spinner>
                                                    <strong>Loading...</strong>
                                                </div>  
            
                                                <template slot="sno" slot-scope="row">
                                                    <div>
                                                        {{ (row.index + 1) + (listingpageno - 1) * perPage }}
                                                    </div>
                                                </template>
                                                <template slot="is_active" slot-scope="row">
                                                    <span class="badge badge-success" v-if="row.item.isactive==1"  style="cursor: pointer;" @click="activeInactive(row.item)">
                                                        Active
                                                    </span>
                                                    <span class="badge badge-danger"  v-if="row.item.isactive==0"  style="cursor: pointer;" @click="activeInactive(row.item)">In Active</span>
            
                                                    <span class="badge badge-success" v-if="row.item.isactive=='Yes'"  style="cursor: pointer;" @click="activeInactive(row.item)">
                                                        Active
                                                    </span>
                                                    <span class="badge badge-danger"  v-if="row.item.isactive=='No'"  style="cursor: pointer;" @click="activeInactive(row.item)">In Active</span>
                                                </template>
                                                <template slot="action" slot-scope="row">
                                                    <div>
                                                        <b-button size="sm" @click="editzonemodelopen(row.item)"><i class="fa fa-pencil" ></i></b-button>
                                                    </div>
                                                </template>
                                            </b-table>
                                        </b-col>
                                    </b-row>
                                </div>
            
                                <b-row class="m-3">
                                    <b-col sm="12" class="text-right">
                                           <p style="margin-top: 5px;"> <b>Total Records :<span style="color:red;"> {{totalRows}}</span></b> </p>
                                    </b-col>
                                    <b-col md="12" class="my-1" >
                                        <paginate 
                                        v-model="pageNum"
                                            :page-count="noofpages"
                                            :page-range="10"
                                            :margin-pages="2"
                                            :click-handler="clickCallback"
                                            :prev-text="'Prev'"
                                            :next-text="'Next'"
                                            :container-class="'pagination'"
                                            :page-class="'page-item'">
                                        </paginate>
                                    </b-col>   
                                </b-row> 
                            </b-tab>
                            
                            <b-tab title="Log Details">
                                <div class="m-3">
                                    <b-row>
                                        <b-col md="12" class="text-right">
                                            <b text-variant="red">Total Records :<span style="color: red;"> {{LogtotalRows}}</span></b>
                                        </b-col>
                                        <b-col md="12">
                                            <b-table show-empty responsive :items="Logitems" :fields="Logfields" :current-page="LogcurrentPage"  :per-page="LogperPage" :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    :outlined="outlined" :busy="LogisBusy"  id="my-table">
                                                <div slot="table-busy" class="text-center text-danger my-2">
                                                    <b-spinner class="align-middle"></b-spinner>
                                                    <strong>Loading...</strong>
                                                </div>  
                                                <template slot="download" slot-scope="row">
                                                    <div>
                                                        <a :href="row.item.file_url" target="_blank" rel="noopener noreferrer">
                                                            <b-button size="sm"><i class="fa fa-download" aria-hidden="true"></i>
                                                            </b-button>
                                                        </a>
                                                    </div>
                                                </template>
                                            </b-table>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col md="12" class="text-right">
                                            <b text-variant="red">Total Records :<span style="color: red;"> {{LogtotalRows}}</span></b>
                                        </b-col>
                                        <b-col md="12">
                                            <b-pagination v-model="LogcurrentPage"  :total-rows="rows" :per-page="LogperPage"
                                            aria-controls="my-table">
                                            </b-pagination>
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>


                    <b-modal title="Edit Zone" v-model="editzonemodel" @ok="editzonemodel=false" hide-footer size="lg">
                        <b-card>
                            <b-form
                            @submit.prevent="validateForm1('form-2')"
                            data-vv-scope="form-2">
                                <b-row>
                                    <div id="listloader" v-if="listloader">
                                        <div class="listloader"></div>
                                    </div>
                                    <div id="overlaymodel" >
                                        <div class="modelloader"></div>
                                      </div>
                                    <b-col md="6">
                                        <b>Zone Name <span style="color: red;">*</span></b>&nbsp;
                                        <b-from-group>
                                            <b-form-input v-model.trim="user.zone_name" placeholder="Enter Zone name" class="mt-2" name="Zone Name" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-2.Zone Name'),
                                            }"></b-form-input>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('Zone Name')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-2.Zone Name')"
                                                class="help text-danger"
                                                >{{ errors.first("form-2.Zone Name") }}</span
                                                >
                                            </b-input-group>
                                        </b-from-group>
                                    </b-col>
                                    <b-col md="12">
                                        <b>Select State <span style="color: red;">*</span></b>&nbsp;
                                        <div class="mt-2" v-if="item_state.length>0">
                                            <b-card style="height: 250px; overflow: scroll;">
                                                <input type="checkbox" @click="checkAll()" v-model="isCheckAll"> &nbsp;
                                                <span style="font-family: SFMono-Regular, Menlo, Monaco, Consolas; font-size: 17px;">Select All</span>
                                                <ul>
                                                  <li v-for="item in item_state" :key="item.id">
                                                    <input class="parentAWBcheckbox" type="checkbox"  v-bind:value="item.state" @change="multiselectdesign($event,item)"  v-model='selectstate' />
                                                    &nbsp;&nbsp;
                                                    <span style="font-family: SFMono-Regular, Menlo, Monaco, Consolas; font-size: 17px;">
                                                      {{ item.state }}
                                                    </span>
                                                  </li>
                                                </ul>
                                            </b-card>
                                        </div>
                                        <div class="mt-2" v-else>
                                            <pre><h6 style="font-size: 18px;">No Data Found</h6></pre>
                                        </div>
                                    </b-col>
                                </b-row>
                                <br>
                                <br>
                                <b-col class="text-right">
                                    <b-button variant="primary" size="md" type="submit"> <i class="fa fa-check-circle-o" aria-hidden="true"></i> Update</b-button> &nbsp;
                                    <b-button variant="danger" @click="clear()"><i class="fa fa-ban" aria-hidden="true"></i> Clear</b-button>
                                </b-col>
                            </b-form>
                        </b-card>
                    </b-modal>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import auth from "@/utils/auth";
export default {
    data() {
        return {
            listloader : false,
            isBusy : false,
            add_zone:false,
            customer : {
                selectclientname :'',
                selectclientservice:'',
                selectedstatus: null,
            },
            clientservice :['B2B','B2C'],
            clientnamelist: [],
            clientname :[],
            options: [
            { value: null, text: 'Please select status' },
            { value: 'Yes', text: 'Yes' },
            { value: 'No', text: 'No' },
            ],
            text:'',

            // upload bulk zone
            uplodCustomer : {
                selectclientname :'',
                selectclientservice:'',
                selectedstatus: null,
            },
            uplodCustomerfile1:'',
            selectcsvFile:'',
            selectFiletype:'',
            // end 


            // search
            search_zone:false,
            searchzonename:'',
            searchstatus :null,

            // list 
            RBZone_list : [],
            totalRows : 0,
            items:[],
            fields:[
                {key:'sno', label:'S.No.'},
                {key:'zone_name', label:'Zone Name'},
                {key:'zone_id',label:'Zone ID'},
                {key:'client_service', label:'Client Service'},
                {key:'clientname', label:'Client Name'},
                {key:'is_active', label:'Is Active'},
                {key:'allocated_state', label:'Allocated State'},
                {key:'createdby',label:'Created By'},
                {key:'createddate',label:'Created Date'},
                {key:'lastmodifiedby',label:'Updated By'},
                {key:'lastmodifieddate', label:'Updated On'},
                {key:'action',label:'Action'}
            ],
            currentPage: 1,
            perPage:  20,
            sortBy: null,
            sortDesc: false,
            sortDirection: 'asc',
            noofpages:'',
            pageNum:1,
            listingpageno:1,

            // edit 
            editzonemodel : false,
            user :{},
            updatezonid :'',
            userlogdata :{},
            isCheckAll : false,
            item_state : [],
            StateList :[],
            selectstate :[],
            assingstate :[],

            showtable:false,
            failureCount:0,
            successCount:0,
            successCSV :'',
            rejectCSV:'',
            uploadid :'',


            // Second Tab Log Dtails
            LogisBusy : false,
            LogtotalRows : 0,
            Logitems:[],
            Logfields:[
                {key:'id', label:'ID'},
                {key:'created_by',label:'Created By'},
                {key:'createddate',label:'Created Date'},
                {key:'download',label:'Download'}
            ],
            LogcurrentPage: 1,
            LogperPage:  20,
        }
    },

    created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.allclientlist()
        this.ZoneList(this.pageNum)
        this.zoneLogList()
    },

    computed: {
      rows() {
        return this.Logitems.length
      }
    },

    methods: {
        downloadsuccessCSV(){
            this.successCSV = `${CONSTANTS.MIGRATION_API_URL}/apiToDownloadSuccesCount?id=`+this.uploadid

            console.log("this.successCSV",this.successCSV)
        },

        downloadrejectCSV(){
            this.rejectCSV = `${CONSTANTS.MIGRATION_API_URL}/apiToDownloadFailureCount?id=`+this.uploadid

            console.log("this.rejectCSV",this.rejectCSV)
        },

        activeInactive(data){
            console.log("data",data)
            this.$fire({
                text: data.isactive=='Yes'?"Do you want to change the status In Active?":"Do you want to change the status Active?",
                type: "warning",
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: "OK",
                cancelButtonText: "Cancel",
                showLoaderOnConfirm: true 
            }).then((result) => {
                console.log("result", result)
                /* Read more about isConfirmed, isDenied below */
                if (result.value) {
                    document.getElementById("overlay").style.display = "block";
                    var userdata = localStorage.getItem("userData");
                    var userInfo = JSON.parse(userdata);

                    const obj = {
                        id : `${data.zone_id}`,
                        isActive : data.isactive=='Yes' || data.isactive=='1' ?'No':'Yes',
                        lastmodifiedby :`${userInfo.userfirstname + ' ' + userInfo.userlastname}`,
                    } 
                    this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/updateIsActiveZoneMaster`,obj)
                    .then((result) => {
                        console.log("result",result)
                        document.getElementById("overlay").style.display = "none";
                        if (result.body.returnmsg=="Successful") {
                            this.$fire({
                                text: result.body.returnmsg,
                                type: "success",
                                timer: 30000,
                            });
                            this.ZoneList(this.pageNum)
                        }
                        else{
                            this.$fire({
                                text: result.body.returnmsg,
                                type: "error",
                                timer: 30000,
                            });
                        }
                    })
                    .catch((ex) => {
                        console.log("error", ex);
                    });
                } else if (result.dismiss) {
                    this.$fire({
                        text: 'Status Is Not Changes',
                        type: "error",
                        timer: 30000,
                    });
                }
            });
        },

        addzone(){
            this.showtable = false
            this.search_zone=false
            this.add_zone=!this.add_zone
            this.clear()
            // this.allclientlist()
        },

        searchzone(){
            this.showtable = false
            this.add_zone=false
            this.search_zone=!this.search_zone
            this.clear()
        },

        clear(){
            this.currentPage=1;
            this.pageNum=1;
            this.errors.clear("form-1");
            this.errors.clear("form-3");
            this.customer={
                selectclientname :'',
                selectclientservice:'',
                selectedstatus: null,
            };
            this.uplodCustomer = {
                selectclientname :'',
                selectclientservice:'',
                selectedstatus: null,
            }
            this.uplodCustomerfile1 ='';
            this.selectcsvFile = '';
            this.selectFiletype = '';
            this.user={}
            this.searchstatus= null;
            this.searchzonename='';
            this.updatezonename='';
            this.selectcity=[];
            this.ZoneList(this.pageNum)
            this.clientnamelist =[];
            this.clientname =[];
            this.getStateList();
            this.allclientlist()   
        },

        checktab(value){
            this.errors.clear("form-1");
            this.errors.clear("form-3");
            this.uplodCustomer = {
                selectclientname :'',
                selectclientservice:'',
                selectedstatus: null,
            },
            this.customer={
                selectclientname :'',
                selectclientservice:'',
                selectedstatus: null,
            };
            this.allclientlist()   
        },

        validateForm(scope) {
            this.$validator.validateAll(scope).then((result) => {
                console.log("-----------",result)
                if (result) {
                    this.addRB_ZoneMasterinfo();
                }
            });
        },

        addRB_ZoneMasterinfo : function () {
            document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            
            const Obj = {
                client_id :  this.customer.selectclientname!=null?this.customer.selectclientname.key:'',
                client_service : this.customer.selectclientservice,
                isactive : this.customer.selectedstatus,
                zone_name : this.customer.text.toLowerCase(),
                createdby : `${userInfo.userfirstname + ' ' + userInfo.userlastname}`,
                sysusermasterid :userInfo.sysusermasterid
            }
            console.log("Obj+++",Obj)
            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/addrbzonemasterinfo`,Obj)
            .then((result) => {
                console.log(result);
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === "Successful") {
                this.$fire({
                    text: result.body.returnvalue,
                    type: "success",
                    timer: 30000,
                });
                this.add_zone = false;
                this.clear();
                this.customer = {};
                this.ZoneList(this.pageNum)
                } else {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "error",
                        timer: 30000,
                    });
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        
        validateForm2(scope){
            this.$validator.validateAll(scope).then((result) => {
                console.log("-----------",result)
                if (result) {
                    this.uploadBulkZoneFile();
                }
            });
        },

        selectcsvFiletoUpload(event) {
            this.selectcsvFile = event.target.files[0];
            console.log("HHH", this.selectcsvFile);

            this.selectFiletype = event.target.files[0].type;
            console.log("selectFiletype", this.selectFiletype);
        },

        uploadBulkZoneFile(){
            document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            if (this.selectFiletype == "text/csv") {
                let csvFile=this.selectcsvFile

                let data = new FormData();
                data.append("file", csvFile);
                data.append("uploaded_by",
                    userInfo.userfirstname + " " + userInfo.userlastname
                );
                
                data.append("client_id", this.uplodCustomer.selectclientname!=null?this.uplodCustomer.selectclientname.key:'');
                data.append("clientname", this.uplodCustomer.selectclientname!=null?this.uplodCustomer.selectclientname.label:'');
                data.append("client_service", this.uplodCustomer.selectclientservice);
                data.append("sysusermasterid", userInfo.sysusermasterid);  

                let config = {
                    header: {
                    "Content-Type": "multipart/form-data",
                    },
                };
                console.log("Config", config);
                // return false;
                this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/uploadBulkZone`, data, {
                    header: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((result) => {
                    console.log(result)
                    document.getElementById("overlay").style.display = "none";
                    if (result.body.returnmsg === "Successful") {
                        this.$fire({
                        text: 'File Uploaded Successfully',
                        type: "success",
                        timer: 30000,
                        });
                        this.uplodCustomerfile1 ='';
                        this.selectcsvFile = '';
                        this.selectFiletype = '';
                        csvFile = '';
                        this.errors.clear("form-3");
                        this.uplodCustomer = {
                            selectclientname :'',
                            selectclientservice:'',
                            selectedstatus: null,
                        }
                        this.add_zone=false;
                        this.ZoneList(this.pageNum);
                        this.zoneLogList()
                        this.showtable = true;
                        this.failureCount = result.body.rejectedCount;
                        this.successCount = result.body.successCount;
                        this.uploadid = result.body.uploadedId;
                        // this.uploadedSuccessRejectCount();
                    }
                    else {
                        this.$fire({
                        text: result.body.returnvalue,
                        type: "error",
                        timer: 30000,
                        });
                        this.showtable = false;
                        this.failureCount = 0;
                        this.successCount = 0;
                        this.uploadid = '';
                        csvFile = '';
                        this.selectcsvFile = "";
                        this.selectFiletype = "";
                    }
                })
            }
            else{
                document.getElementById("overlay").style.display = "none";
                this.$fire({
                    text: "Please Upload CSV File Only",
                    type: "error",
                    timer: 30000,
                });
                this.showtable = false;
                this.uplodCustomerfile1 ='';
                this.selectcsvFile = '';
                this.selectFiletype = '';
                csvFile = '';
            }
        },

        allclientlist(){
            this.clientnamelist =[];
            this.clientname =[];
            const Obj = {}
            // return false;
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getallclientlist`,Obj)
            .then((result) => {
                console.log("result",result)
                if (result.body.returnmsg === "Successful") {
                    this.clientnamelist = result.body.returnvalue;

                    this.clientnamelist.forEach(value => {
                        var client = {
                            key:value.clientmasterid,
                            label:value.clientname
                        }
                        this.clientname.push(client)
                        if (value.clientmasterid==27 && value.clientname=="Firstcry") {
                            this.customer.selectclientname = client;
                        }
                        if (value.clientmasterid==27 && value.clientname=="Firstcry") {
                            this.uplodCustomer.selectclientname = client;
                        }
                    });
            
                } else {
                    this.clientnamelist =[];
                    this.clientname =[];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        clickCallback (pageNum){
            this.listingpageno = pageNum;
            this.ZoneList(pageNum);
        },

        ZoneList(pageNum){
            this.items =[];
            this.totalRows=0;
            this.isBusy=true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            
            const Obj = {
                sysusermasterid : userInfo.sysusermasterid,
                page_no :pageNum,
                zone_name : this.searchzonename==""?"": this.searchzonename,
                isactive : this.searchstatus==null?"":this.searchstatus
            }
            console.log("TTTTTTTT",Obj);
            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/getZonemasterList`,Obj)
            .then((result) => {
                this.isBusy=false;
                if (result.body.returnmsg === "Successful") {
                    this.items = result.body.returnvalue;
                    this.totalRows = result.body.returnvalue[0].totalcount;
                    this.noofpages=parseInt(this.totalRows)/20;
                    this.noofpages=Math.ceil( this.noofpages);

                    // for (let i = 0; i <  this.items.length; i++) {
                    //     const element =  this.items[i].allocated_state;
                    //     this.assingstate.push(element)
                    // }
                    // this.assingstate = this.assingstate.flatMap(item => item.split(','));
                    // console.log("assingstate",this.assingstate)
                } else {
                    this.items =[];
                    this.totalRows=0;
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        editzonemodelopen(data){
            console.log(data)
            this.selectstate = [];
            this.user.zone_name = data.zone_name;
            this.userlogdata = data;
            console.log("userlogdata",this.userlogdata)
            this.updatezonid = data.zone_id;
            if (data.allocated_state!=null && data.allocated_state!=undefined) {
                console.log("-------------",data.allocated_state)
                const myArray = data.allocated_state.split(",");
                this.selectstate = myArray
                console.log(" this.selectstate", this.selectstate)
            }
            this.search_zone=false
            this.add_zone=false
            this.editzonemodel=!this.editzonemodel
            this.getStateList()
        },

        validateForm1(scope) {
            this.$validator.validateAll(scope).then((result) => {
                console.log("-----------",result)
                if (result) {
                    this.updateZonedetails();
                }
            });
        },

        updateZonedetails(){
            document.getElementById("overlaymodel").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            console.log("userInfo",userInfo)

            if (this.selectstate.length==0) {
                this.$fire({
                    text: 'Please Select AT Least One State',
                    type: "error",
                    timer: 30000,
                });
                document.getElementById("overlaymodel").style.display = "none";
                return false;
            }
            const Obj = {
                zone_id :  this.updatezonid,
                zone_name : this.user.zone_name.toLowerCase(),
                allocated_state : this.selectstate,
                lastmodifiedby : `${userInfo.sysemailid}`,
            }
            console.log("Obj",Obj)
            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/editrbzonemaster`,Obj)
            .then((result) => {
                console.log(result);
                document.getElementById("overlaymodel").style.display = "none";
                if (result.body.returnmsg === "Successful") {
                this.$fire({
                    text: result.body.returnvalue,
                    type: "success",
                    timer: 30000,
                });
                this.editzonemodel = false;
                this.clear();
                this.user = {};
                this.ZoneList(this.pageNum)
                } else {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "error",
                        timer: 30000,
                    });
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        checkAll: function(){

            this.isCheckAll = !this.isCheckAll;
            this.selectstate = [];

            if(this.isCheckAll){ // Check all

                for (var key in this.item_state) {
                    this.selectstate.push(this.item_state[key].state);
                }
            }
            console.log(" this.selectstate", this.selectstate)
        },

        multiselectdesign(e,value){
            console.log(" this.selectstate", this.selectstate)
            if(this.selectstate.length == this.item_state.length){
                this.isCheckAll = true;
            }
            else{
                this.isCheckAll = false;
            }
        },

        getStateList(){
            this.listloader = true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            
            const Obj = {
                country : "",
                state : "",
                city : "",
                pincode : ""
            }
            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/getStateCityPincodes`,Obj)
            .then((result) => {
                this.listloader = false;
                console.log("result",result)
                if (result.body.returnmsg === "Successful") {
                    this.item_state = result.body.returnvalue;
                } 
                else{
                    this.item_state =[];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },


        zoneLogList(){
            this.Logitems =[];
            this.LogtotalRows=0;
            this.LogisBusy=true;
            
            const Obj = {}
            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/bulkzoneloglisting`,Obj)
            .then((result) => {
                this.LogisBusy=false;
                if (result.body.returnmsg === "Successful") {
                    this.Logitems = result.body.returnvalue;
                    this.LogtotalRows = result.body.returnvalue.length;
                } else {
                    this.Logitems =[];
                    this.LogtotalRows=0;
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },
    },
}
</script>

<style scoped>
.nav-tabs .nav-link.active {
    color: #2f353a;
    background: #fff;
    border-color: #c8ced3;
    border-bottom-color: #fff;
    font-weight: bold;
}
</style>